import { z } from 'zod';

/** One context compaction the Agent SDK performed on a conversation's query
 *  (context_compactions row). A failed compaction has no trigger or token
 *  counts, only the SDK's error text. */
export const ContextCompactionSchema = z.object({
  id: z.string(),
  jobId: z.string().nullable(),
  /** 'main' for the conversation's own turn, 'merit-function' for a merit
   *  side-agent run, whose compaction the main context never sees. */
  agentSource: z.string(),
  sdkSessionId: z.string(),
  trigger: z.enum(['auto', 'manual']).nullable(),
  preTokens: z.number().nullable(),
  postTokens: z.number().nullable(),
  durationMs: z.number().nullable(),
  result: z.enum(['success', 'failed']),
  error: z.string().nullable(),
  createdAt: z.string(),
});
export type ContextCompaction = z.infer<typeof ContextCompactionSchema>;

export const ContextCompactionListSchema = z.object({
  compactions: z.array(ContextCompactionSchema),
});
